import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { SemanticError } from '../../color-palette/colors';

export const dangerToneSx: SystemStyleObject<Theme> = {
  color: SemanticError[600],
  borderColor: SemanticError[600],
  '&:hover': { borderColor: SemanticError[600] },
};
